import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";
import { Collapse } from "antd";

const faqs = [
  {
    question: "What types of office files can I convert to PDF?",
    answer:
      "You can convert Word documents (DOC, DOCX), Excel spreadsheets (XLS, XLSX), and PowerPoint presentations (PPT, PPTX) to PDF.",
  },
  {
    question: "Can I convert images to PDF?",
    answer:
      "Yes! You can easily convert popular image formats such as JPG, PNG, BMP, and GIF to PDF files.",
  },
  {
    question: "How do I create a QR Code using your tool?",
    answer:
      'Simply enter the text, URL, or data you want to encode, click on the "Create QR Code" button, and download your custom QR Code.',
  },
  {
    question: "Do I need to install any software to use these tools?",
    answer:
      "No software installation is required for the website—everything runs in your browser.",
  },
  {
    question: "Do you have a mobile app?",
    answer:
      "Yes! We offer a mobile app for iOS and Android. You can download it from the App Store or Google Play Store and access all our tools on the go.",
  },
  {
    question:
      "Is it safe to upload my documents to your website or mobile app?",
    answer:
      "Yes! We take data security seriously. All uploaded files are processed securely and are automatically deleted after a short period.",
  },
  {
    question: "Can I convert multiple files at once (batch conversion)?",
    answer:
      "Currently, we support one file at a time. We’re working on adding batch conversion features—stay tuned!",
  },
  {
    question: "Are there any file size limits?",
    answer:
      "We recommend uploading files under 10 MB for a fast and reliable experience.",
  },
  {
    question: "Are the website and mobile app free to use?",
    answer:
      "Yes, all basic features are free. In the future, we may introduce premium plans for advanced options like larger file sizes or batch conversion.",
  },
  {
    question: "How do I get support if I have issues or questions?",
    answer:
      "If you need help, you can reach out to our support team directly through the contact form on our website or via the Help section in our mobile app.",
  },
];

const FAQ = () => {
  const [searchParams] = useSearchParams();
  const isModule = searchParams.get("app");

  return (
    <>
      {isModule === "true" ? [] : <HeaderLayout />}
      <div>
        <div
          style={{
            padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2 align="center">Frequently Asked Questions</h2>
          <br />
          <br />
          <Collapse className="faq-collapse">
            {faqs.map((faq, index) => (
              <Collapse.Panel
                header={faq.question}
                key={index}
                className="faq-panel"
              >
                <p>{faq.answer}</p>
              </Collapse.Panel>
            ))}
          </Collapse>
          <br />
          <br />
        </div>
      </div>
      {isModule === "true" ? [] : <FooterLayout />}
    </>
  );
};

export default FAQ;
